import { UrlManager } from '@skapiec/lib-url-manager';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { useCallback, useMemo } from 'react';
import { ProducerUrlManagerInterface } from 'modules/producers/interfaces/producer-url-manager.interface';
import { ProducerStateInterface } from 'modules/producers/interfaces/producer-state.interface';

export type useProducerUrlType = (
    data?: (Partial<ProducerUrlManagerInterface
        & { addFilters?: string[] | undefined; subFilters?: string[] | undefined; }> | undefined)) => string;

export const useProducerUrl = (): useProducerUrlType => {
    const filters = useSelector((state: ProducerStateInterface) => state.category?.filters || { groups: [] });
    const params = useSelector((state: ProducerStateInterface) => state.producerUrlManager);

    const maps = useMemo(() => {
        const map = new Map<string, [number, number]>();

        filters.groups.forEach(group => {
            group.entries.forEach(entry => {
                map.set(entry.id, [group.position, entry.position]);
            });
        });

        return map;
    }, [filters]);

    return useCallback((data?: Partial<ProducerUrlManagerInterface & { addFilters?: string[]; subFilters?: string[]; }>): string => {
        const filters: Record<number, number[]> = {};

        if (params?.filters?.length || data?.filters?.length || data?.addFilters?.length || data?.subFilters?.length) {
            let items: string[] = data?.filters ? [...data.filters] : [...params.filters ?? []];

            if (data?.addFilters) {
                items.push(...data.addFilters);
            }

            if (data?.subFilters) {
                items = items.filter(id => data?.subFilters?.includes(id) === false);
            }

            items.forEach(id => {
                const data = maps.get(id);

                if (data) {
                    if (filters[data[0]]) {
                        filters[data[0]].push(data[1]);
                    } else {
                        filters[data[0]] = [data[1]];
                    }
                }
            });
        }

        return UrlManager.producerPage.view({ ...params, ...data, filters });
    }, [maps, params]);
};
